<div class="router-bar" *ngIf="!isMobile">
  <div class="materials-order-route">
    <button mat-button [routerLink]="['/timesheets/approvals']"
            [ngClass]="{'current-route': router.url === '/timesheets/approvals'}">Approvals
    </button>
  </div>
  <div class="materials-order-route vacation-button">
    <button mat-button [routerLink]="['/timesheets/vacations']"
            [ngClass]="{'current-route': router.url === '/timesheets/vacations'}">
      PTO
      <span class="vacation-badge" *ngIf="vacationCounter > 0">{{vacationCounter}}</span>
    </button>
  </div>
</div>
<router-outlet></router-outlet>
